import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FileTextIcon, SunIcon, ZapIcon, HeartIcon, CheckSquareIcon } from 'lucide-react';
export function ContentsSection() {
  const contents = [{
    icon: BookOpenIcon,
    title: '12 módulos con explicación clara + ejercicios'
  }, {
    icon: FileTextIcon,
    title: 'Plantillas listas para completar'
  }, {
    icon: SunIcon,
    title: 'Rutina maestra de manifestación (mañana/noche)'
  }, {
    icon: ZapIcon,
    title: 'Herramientas de regulación (recalibración vibracional)'
  }, {
    icon: HeartIcon,
    title: 'Diario de reconciliación con el dinero'
  }, {
    icon: CheckSquareIcon,
    title: 'Checklists semanales de alineación (abundancia + autoestima)'
  }];
  return <section className="w-full bg-cream-50 py-20 md:py-28 px-4" data-id="element-38">
      <div className="max-w-4xl mx-auto" data-id="element-39">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-3xl md:text-4xl text-brown-700 text-center mb-12" data-id="element-40">
          Qué incluye
        </motion.h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-41">
          {contents.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 shadow-md shadow-gold-500/10 border border-gold-50 text-center" data-id="element-42">
                <div className="w-14 h-14 bg-gradient-to-br from-gold-100 to-gold-200 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-43">
                  <Icon className="w-7 h-7 text-gold-600" data-id="element-44" />
                </div>
                <p className="text-brown-600 font-medium" data-id="element-45">{item.title}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center bg-gold-50 rounded-2xl p-6 border border-gold-200" data-id="element-46">
          <p className="text-brown-700 font-medium" data-id="element-47">
            <span className="text-gold-600 font-semibold" data-id="element-48">Formato:</span> PDF —
            lo descargás y lo usás a tu ritmo.
          </p>
        </motion.div>
      </div>
    </section>;
}